import { render, staticRenderFns } from "./PublicEventCard.vue?vue&type=template&id=056f8340&scoped=true&"
import script from "./PublicEventCard.vue?vue&type=script&lang=ts&"
export * from "./PublicEventCard.vue?vue&type=script&lang=ts&"
import style0 from "./PublicEventCard.vue?vue&type=style&index=0&id=056f8340&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056f8340",
  null
  
)

export default component.exports